import httpClient from './httpClient'

const TemporaryCampaignApi = {
  async getIncomplete() {
    try {
      const res = await httpClient.get(`/campaign/temporary`)
      return res.data
    } catch (e) {
      console.log(e)
      throw e
    }
  },
  async create(body) {
    try {
      const res = await httpClient.post('/campaign/temporary', body)
      return res.data
    } catch (e) {
      console.log(e)
      throw e
    }
  },
  async update(id, body) {
    try {
      const res = await httpClient.put(`/campaign/temporary/${id}`, body)
      return res.data
    } catch (e) {
      console.log(e)
      throw e
    }
  },
  async setComplete(campaignId) {
    try {
      const res = await httpClient.post(
        `/campaign/temporary/${campaignId}/settingComplete`,
      )
      return res.data
    } catch (e) {
      console.log(e)
      throw e
    }
  },
}

export default TemporaryCampaignApi
